<template>
  <div>
    <van-stepper v-if="type==='number'" class="card-number" v-model="dataValue" integer input-width="40px" button-size="32px" min="0" />
    <span v-else>{{ dataValue }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dataValue: '',
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dataValue = val
      },
      immediate: true,
    },
    dataValue(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .card-number {
  .van-stepper__minus,
  .van-stepper__plus {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Grid/GridColumn.vue